import React from 'react'

const CompanyStructure = () => {
  return (
    <div>CompanyStructure</div>
  )
}

export default CompanyStructure